import Reports from "./reports"

export default Reports
